import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import ProjectEditor from "@/pages/ProjectEditor";
import RoomEditor from "@/pages/RoomEditor";
import ExteriorEditor from "@/pages/ExteriorEditor";
import DeckEditor from "@/pages/DeckEditor";
import CabinetEditor from "@/pages/CabinetEditor";
import Summary from "@/pages/Summary";
import ProposalGenerator from "@/pages/ProposalGenerator";
import Settings from "@/pages/Settings";

function AppRoutes() {
  return (
    <Routes>
      {/* Optional sign-in (for cloud sync / admin). App is fully usable without it. */}
      <Route path="/login" element={<Landing />} />
      <Route path="/" element={<Dashboard />} />
      <Route path="/project/:projectId" element={<ProjectEditor />} />
      <Route path="/project/:projectId/room/:roomId" element={<RoomEditor />} />
      <Route path="/project/:projectId/exterior/:sideId" element={<ExteriorEditor />} />
      <Route path="/project/:projectId/deck/:deckId" element={<DeckEditor />} />
      <Route path="/project/:projectId/cabinet/:cabinetId" element={<CabinetEditor />} />
      <Route path="/project/:projectId/summary" element={<Summary />} />
      <Route path="/project/:projectId/proposal" element={<ProposalGenerator />} />
      <Route path="/settings" element={<Settings />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark min-h-screen bg-background">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
